import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import 'rsuite/lib/styles/index.less';
import { App } from './App';
import './App.scss';
import { Equipment } from './Equipment';
import { EquipmentContext } from './utils/scope';

// $(() => {
$('.nh2-equipment').each(function () {
  ReactDOM.render(
    <App>
      <EquipmentContext.Provider value="equipment">
        <Equipment />
      </EquipmentContext.Provider>
    </App>,
    this,
  );
});

$('.nh2-parts').each(function () {
  ReactDOM.render(
    <App>
      <EquipmentContext.Provider value="parts">
        <Equipment />
      </EquipmentContext.Provider>
    </App>,
    this,
  );
});
// });
